/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component } from 'react';

export default class HomePage extends Component {

    constructor (props) {
        super(props);
    }

    render() {
        return (
            <div className="home-page">
                <h1>{this.props.homeTitle}</h1>
                <a href="/print-book/0ac702be-5e04-134f-815e-08a33a5600b3/accessCode-setup">Go To Book Details</a>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/HomePage/HomePage.js